import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, Trash } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { NotificationPosition } from 'core/enums';
import { EditLogButton, RemoveLogsButton } from 'jobs/components/JobDetails';
import { Color, Direction, Level } from 'theme/enums';

export const ActionsCell = ({ data }: ICellRendererParams) => {
  if (!data) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <EditLogButton
        log={data}
        buttonElement={
          <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <PencilSimpleLine />
          </Typography>
        }
      />
      <RemoveLogsButton
        logs={[data]}
        buttonElement={
          <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <Trash />
          </Typography>
        }
        notificationPosition={NotificationPosition.TOP}
      />
    </Stack>
  );
};
